import UserCreateInfoFormView from "./user-create-info-form.view";
import UserCreateCountryMapFormView from "./user-create-country-map-form.view";
import UserCreateUdfFormView from "./user-create-udf-form.view";
import log from "../../../../utils/logger";
import ViewBase from "../../../view-base.view";
import loginModel from "../../../../models/login.model";
import '../../../../utils/extensions';
import modelBase from "../../../../models/model-base.model";
import userModel from "../../../../models/user/user.model";
import { Spinner } from 'construct-ui';
import { messageComponent } from '../../../../components/message/message.component';

export default function UserCreateView() {
    ViewBase.call(this);

    const ID_COUNTRY_MAP_FORM = 'countryMapForm';
    const COUNTRY_MAP_TYPES = {
        ADMIN_YN: 'admin',
        REQUIRED_APPROVAL: 'requiredApproval',
        BU: 'BU',
        GSCMDIV: 'gscmDivisions',
        RETAILDIV: 'retailDivisions',
        USERROLE: 'userRole',
        REGION: 'managedLocations',
        SITEGROUP: 'managedSiteGroups',
        SITE: 'managedSites'
    };

    let onSaved = (a) => { }
    let isLoading = false;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";
    let _isInfoValid = true, _isUdfValid = true;
    let _needReset = true;
    let _infoForm = {};
    let _countryMapForm = {};
    let _udfForm = [];
    let needToValidate = false;
    let msgList = [];

    let _user = {
        userInfo: {},
        userCountryMap: [],
        userUDF: []
    };

    let getInfo = (info, isValid) => {
        // Country was changed, reset _countryMapForm
        if (_infoForm.countryCode !== info.countryCode) {
            _countryMapForm = { [info.countryCode]: {} };
        }

        _infoForm = structuredClone(info);
        _isInfoValid = isValid;
    }

    let getCountryMap = (user) => {
        _countryMapForm = user.countryMap;
    }

    let getUdf = (udf, isValid) => {
        _udfForm = udf;
        _isUdfValid = isValid;
    }

    var finalizeData = () => {
        if (_infoForm?.photo?.file != undefined && _infoForm.photoGUID != '') {
            modelBase.uploadfile((result) => {
                _infoForm.photoGuid = result[0]?.id;
                _finalizeDataAndSubmit();
            }, (error) => {
                log.e(error);
            }, _infoForm?.photo?.file, 'User');
        } else {
            return _finalizeDataAndSubmit();
        }
    }

    var _finalizeDataAndSubmit = () => {
        isLoading = true;
        _user.userInfo = setInfoForm();
        _user.userCountryMap = setCountryMapForm();
        _user.userUDF = setUdfForm();
        userModel.createUser(
            (result) => {
                isLoading = false;
                onSaved(result);
            }, (error) => {
                isLoading = false;
                isMsgOpen = true;

                if (error.code == 400) {
                    showMsg = error.response[0].message;
                    msgTitle = this.getText("EM00000108", "Validation Error");
                } else {
                    this.handleError(error);
                }
            },
            _user);
    }

    let setInfoForm = () => {
        var ret = {
            userId: _infoForm.userId,// "string",
            password: _infoForm.password,// "string",
            userType: _infoForm.userType,// "string",
            countryCode: _infoForm.countryCode,// "string",
            divisionGroup: _infoForm.divisionGroup,// ["string"],
            knoxID: _infoForm.knoxID,// "string",
            userName: _infoForm.userName,// "string",
            email: _infoForm.email,// "string",
            languageCode: _infoForm.languageCode,// "string",
            mobileNumber: _infoForm.mobileNumber,// "string",
            userStatus: _infoForm.userStatus,// "string",
            salesForceYN: 'Y',// "string", ---------
            salesForceType: _infoForm.salesForceType,// "string",
            salesForceRankType: _infoForm.salesForceRankType,// "string",
            employmentType: _infoForm.employmentType,// "string",
            userGrade: _infoForm.userGrade,// "string",
            supervisor: _infoForm.supervisor,// "string",
            supervisorName: _infoForm.supervisorName,// "string",
            agencyCode: _infoForm.agencyCode,// "string",
            dateOfBirth: _infoForm.dateOfBirth,//_formatDateYyyyMMdd(userInfo.dateOfBirth),// "string",
            jobStartDate: _infoForm.jobStartDate,//_formatDateYyyyMMdd(userInfo.jobStartDate),// "string",
            jobEndDate: _infoForm.jobEndDate,//_formatDateYyyyMMdd(userInfo.jobEndDate),// "string",
            educationDegreeCode: _infoForm.educationDegreeCode,// "string",
            gender: _infoForm.gender,// "string",
            workingExperience: _infoForm.workingExperience,// "string",
            previousCompany: _infoForm.previousCompany,// "string",
            additionalInfo: _infoForm.additionalInfo,// "string",
            photoGUID: _infoForm.photoGuid,// "string",
            seaoUser: _infoForm.seaoUser,// "string" 
            faceRecognitionYN: _infoForm.faceRecognitionYN
        };
        return ret;
    }

    let setCountryMapForm = () => {
        const result = [];
        for (const [countryCode, countryDetails] of Object.entries(_countryMapForm)) {
            const obj = {
                countryCode,
                user: _infoForm.userId,
                userRole: countryDetails[COUNTRY_MAP_TYPES.USERROLE],
                adminYN: countryDetails[COUNTRY_MAP_TYPES.ADMIN_YN] ? 'Y' : 'N',
                requiredApprovalYN: countryDetails[COUNTRY_MAP_TYPES.REQUIRED_APPROVAL] ? 'Y' : 'N',
                bu: countryDetails[COUNTRY_MAP_TYPES.BU],
                managedRegion: countryDetails[COUNTRY_MAP_TYPES.REGION],
                retailDivision: countryDetails[COUNTRY_MAP_TYPES.RETAILDIV],
                gscmDiv: countryDetails[COUNTRY_MAP_TYPES.GSCMDIV],
                managedSite: countryDetails[COUNTRY_MAP_TYPES.SITE]?.map(site => site.code),
                managedSiteGroup: countryDetails[COUNTRY_MAP_TYPES.SITEGROUP]?.map(siteGroup => siteGroup.code),
            };
            result.push(obj);
        }
        return result;
    }

    var setUdfForm = () => {
        return _udfForm.map(e => (
            {
                countryCode: e.countryCode,
                udfId: e.attributeId,
                udfValue: e.valueId
            }
        ));
    }

    var submitNewUser = () => {
        if (isCountryMapValid() && _isInfoValid && _isUdfValid) {
            finalizeData();
        }
        else {
            needToValidate = true;
            isMsgOpen = true;
            showMsg = this.getText("EM00000310", "Please fill in all required fields.");
            msgTitle = this.getText("EM00000142", "Error");
        }

    }

    const isCountryMapValid = () => {
        // Form validation
        let form = document.getElementById(ID_COUNTRY_MAP_FORM);
        form.classList.add('was-validated');
        return form.checkValidity();
    }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    return {
        oninit: (vnode) => {
            this.initState(vnode.state);
            this.state.defaultCountry = {
                code: loginModel.credentials?.country,
                name: '',
                isChanged: true,
                countryMapLoaded: false,
                countryUdfLoaded: false,
                seaoUser: false,
            };
            _countryMapForm[loginModel.credentials?.country] = {};
            if (vnode.attrs.onSaved) {
                onSaved = vnode.attrs.onSaved;
            }
        },
        view: () => {
            return [
                m('.card',
                    m('.p-4',
                        m('.row',
                            m(Spinner, {
                                active: isLoading,
                                background: true,
                                fill: true,
                                size: 'xl',
                            }),
                            _needReset && m(".mb-3.mt-1", [
                                m(UserCreateInfoFormView, { submit: getInfo, defaultCountry: this.state.defaultCountry, isnew: '1', needToValidate: needToValidate }),
                                m("hr.my-4"),
                                m(`form#${ID_COUNTRY_MAP_FORM}.form.needs-validation[novalidate]`, { onsubmit: (e) => { e.preventDefault() } },
                                    m(UserCreateCountryMapFormView, {
                                        user: {
                                            defaultCountryCode: _infoForm.countryCode,
                                            countryMap: _countryMapForm
                                        },
                                        onChange: getCountryMap
                                    })
                                ),
                                m("hr.my-4"),
                                m(UserCreateUdfFormView, { submit: getUdf, defaultCountry: this.state.defaultCountry }),
                                m("hr.my-4"),
                                m(".d-grid.g.ap-2.d-flex.justify-content-end",
                                    m("button.btn.btn-primary.btn-lg.px-4.gap-3", { style: "margin-right:10px;", onclick: submitNewUser }, this.getText("LT00000005", "Submit")),
                                ),
                            ]),
                        ),
                    ),
                ),
                m(messageComponent, { isOpen: isMsgOpen, message: showMsg, messageList: msgList, title: msgTitle, onClosed: _dialogClosed }),
                this.getBaseViews()
            ];
        },
    };
}
